var _rect, _rect2, _rect3, _path, _path2, _circle, _circle2, _g, _circle3, _g2, _rect4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHrBigIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 76,
    viewBox: "0 0 71 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 71,
    height: 76,
    fill: "#ACACAC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -159,
    y: -185,
    width: 469,
    height: 530,
    rx: 3,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: -36,
    y: -20.0581,
    width: 152,
    height: 134,
    rx: 4,
    fill: "#EFF8F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.3169 20.0447C43.3169 20.0447 55.9538 21.5481 54.9426 33.5773C53.9314 45.6064 44.3276 59.1401 33.7126 62.6488C31.8592 63.15 27.827 63.2212 25.1195 62.1475C20.065 60.1431 4.39497 49.6162 5.91136 33.5773C6.2472 30.0251 7.33511 27.4891 8.94446 25.7514M43.3169 20.0447C43.3169 20.0447 35.735 23.0518 33.2074 26.5604M43.3169 20.0447C48.1671 18.4767 51.2223 18.2457 53.8248 18.434C54.4214 18.4772 54.9429 18.0156 54.9428 17.4174L54.9427 11.3705C54.9426 10.8807 54.5889 10.461 54.1028 10.4003C50.9328 10.0045 46.3928 10.0796 41.8005 11.3845M33.2074 26.5604C31.6912 30.069 31.1855 33.5773 31.1855 37.5876C31.1855 42.0987 32.7019 45.1061 33.2074 46.1086M33.2074 26.5604C30.5841 25.2798 29.6443 25.0397 26.6362 24.1113M33.2074 46.1086V52.1234M33.2074 46.1086L40.284 44.6049M26.6362 24.1113C23.3648 23.1017 20.0384 22.4633 17.0321 22.5503M26.6362 24.1113C29.9148 16.7668 35.9008 13.0608 41.8005 11.3845M17.0321 22.5503C13.8173 22.6434 10.9685 23.566 8.94446 25.7514M17.0321 22.5503C16.1057 20.8801 15.0756 19.4563 13.9992 18.2472M8.94446 25.7514C7.53353 23.0882 4.22524 21.2085 2.17307 20.3535C1.71332 20.162 1.43108 19.6809 1.52361 19.1916L2.71544 12.8883C2.80883 12.3944 3.25404 12.0433 3.74987 12.126C6.22668 12.539 10.3751 14.1761 13.9992 18.2472M13.9992 18.2472C14.6732 16.8413 15.5606 15.6724 17.664 14.0948L14.5249 8.88683C14.2361 8.40778 14.3964 7.78504 14.8806 7.50498L19.2968 4.95047C19.7351 4.69697 20.2936 4.811 20.5975 5.21598L24.1558 9.9591C24.4265 10.3199 24.9051 10.4548 25.3244 10.2885L29.0377 8.81569C29.4188 8.66454 29.669 8.2961 29.669 7.88614V3C29.669 2.44771 30.1167 2 30.669 2H36.2512C36.8035 2 37.2512 2.44772 37.2512 3V7.01233C38.4306 7.75509 40.9917 9.66938 41.8005 11.3845",
    stroke: "#252525",
    strokeWidth: 2.3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7077 45.1208L23.7387 39.1426M23.7387 39.1426L30.8106 36.1812M23.7387 39.1426L17.1382 36.6517",
    stroke: "#252525",
    strokeWidth: 2.3,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 54,
    cy: 58.9421,
    r: 16,
    fill: "#EFF8F9",
    stroke: "#252525",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_86_56220",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 41,
    width: 34,
    height: 35
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 54,
    cy: 58.9421,
    r: 16,
    fill: "white",
    stroke: "white",
    strokeWidth: 2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_86_56220)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_86_56220",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 40,
    y: 45,
    width: 28,
    height: 28
  }, _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 54,
    cy: 59,
    r: 12.8,
    fill: "white",
    stroke: "white",
    strokeWidth: 1.6
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_86_56220)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.3489 59.3588C77.3489 59.7882 77.0042 60.1349 76.5794 60.1349H66.4994C66.3752 60.1349 66.2603 60.2094 66.2069 60.3232L65.3337 62.1975C65.1202 62.6559 64.6748 62.9405 64.1731 62.9405C63.9043 62.9405 63.6529 62.8598 63.4456 62.7139C63.2609 62.5866 63.1111 62.4096 63.0115 62.1943L62.1454 60.3232C62.092 60.2094 61.977 60.1349 61.8519 60.1349H58.9448C58.1711 60.1349 57.4692 59.6444 57.1994 58.9127L56.359 56.6401L53.9752 63.785C53.7997 64.3118 53.3123 64.6657 52.7613 64.6657C52.202 64.6625 51.7146 64.3055 51.5422 63.7746L49.0455 56.0896L47.8705 59.3671C47.6048 60.1081 46.9009 60.6069 46.1189 60.6069H36.7696C36.3447 60.6069 36 60.2593 36 59.8308C36 59.4024 36.3447 59.0547 36.7696 59.0547H46.1189C46.2554 59.0547 46.3775 58.9678 46.4237 58.8394L47.8521 54.853C48.0409 54.3263 48.5201 53.9899 49.0773 54.0002C49.6324 54.0086 50.1024 54.3584 50.2759 54.8903L52.7644 62.5494L55.1317 55.4512C55.3072 54.9255 55.776 54.5799 56.3261 54.5705C56.874 54.5623 57.3563 54.8924 57.5482 55.4119L58.641 58.3707C58.6882 58.498 58.8103 58.5828 58.9447 58.5828H61.8518C62.5732 58.5828 63.2351 59.0092 63.5398 59.6674L64.174 61.0365L64.8143 59.6632C64.9836 59.2979 65.2648 59.0041 65.6044 58.8167C65.8742 58.6656 66.1811 58.5828 66.4992 58.5828H76.5792C77.0042 58.5826 77.3489 58.9304 77.3489 59.3588Z",
    fill: "#252525",
    stroke: "#EFF8F9",
    strokeWidth: 0.5
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: -159,
    y: -185,
    width: 469,
    height: 530,
    rx: 3,
    stroke: "#E5E5E5",
    strokeMiterlimit: 0,
    strokeLinejoin: "bevel"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHrBigIcon);
export default __webpack_public_path__ + "static/media/hr-big-icon.f892cc4887192577c1192c7eb0988355.svg";
export { ForwardRef as ReactComponent };